import { Badge, Tooltip } from '@shopify/polaris';
import { formatToCurrency } from '../functions';
import { intentMeta } from './paymentIntents';

/*
  Badge for the pending bank payment of a supplier invoice.
  intent: { state | Status, Amount, CreatedAt, PontoPaymentID } or the flat list-row fields (payment_intent_*).
*/
export default function PaymentIntentBadge({ intent, state, amount, createdAt, id, size }) {
  const resolvedState = state || intent?.state || intent?.Status;
  if (!resolvedState) return null;
  const meta = intentMeta(resolvedState);
  const resolvedAmount = amount ?? intent?.Amount;
  const resolvedCreated = createdAt ?? intent?.CreatedAt;
  const resolvedId = id ?? intent?.PontoPaymentID;
  const detail = [
    resolvedAmount != null ? formatToCurrency(resolvedAmount) : null,
    resolvedCreated ? `sent ${String(resolvedCreated).substring(0, 10)}` : null,
    resolvedId ? `Ponto payment #${resolvedId}` : null
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <Tooltip content={`${meta.hint}${detail ? ` ${detail}` : ''}`}>
      <Badge tone={meta.tone} size={size}>
        {meta.label}
      </Badge>
    </Tooltip>
  );
}
